export default {
  state: {
    expandedMenu: null
  },

  mutations: {
    MENU_STATE (state, flag) {
      state.expandedMenu = flag
    }
  },

  actions: {
    setMenuState: ({ commit }, flag) => {
      commit('MENU_STATE', flag)
    }
  },

  getters: {
    expandedMenu: state => state.expandedMenu
  }
}



// WEBPACK FOOTER //
// ./client/store/modules/menu.js